import { ValidationErrors } from '@angular/forms';

export class TableDataCellState {
	invalid  = false;
	readOnly = true;

}
